import {
	defineStore
} from 'pinia'
import {
	ref
} from 'vue'
import {
	getInfo,
	getInfoProject,
	cacheGetCacheType,
	configusersafeInfo,
	corecollectListAll,
	sysmenupowerDynamicMenu,
	configuserpersonalizedInfo
} from '@/api/user'
import {
	configcompanydeployInfo
} from '@/api/groupAccount'
import {
	sysnoticeconfigPlatformShow,
	sysnoticeservicestationTopNuminfo,
	sysnoticestationletterUserStationLetterNum
} from '@/api/systemNotification'
import {
	configarchiveInfo,
	archivedeviceapplyApprovalNum
} from '@/api/archivePage'
import {
	configprojecttrackingInfo
} from '@/api/project'
import {
	configmenucustomizeInfo
} from '@/api/pathPage'
import {
	configcompanyserviceInfo
} from '@/api/enterpriseOperation';

const useUserStore = defineStore('user', () => {
	const userInfo = ref(localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {})
	const loginStatus = ref(false)
	const token = ref('')
	const cachedViews = ref(['GeneralArchive', 'MemberArchive', 'ExpirationWarning', 'EquipmentRegistration',
		'EquipmentApproval', 'MemberAccount', 'DepartmentManagement', 'ChangeLogs', 'ProjectCenter',
		'MyToDo', 'MyCreate', 'ItemsRequiringAssistance', 'PathInformation', 'ServiceStation',
		'ProductDescriptionGenerator', 'UpdateNotesGenerator', 'ProjectDashboard',
		'ProjectLeaderRankingList', 'ModuleCreateRankingList', 'ModuleChargeRankingList',
		'ModuleFinishRankingList', 'RequirementAssistantRankingList', 'RequirementCreateRankingList',
		'RequirementFinishRankingList', 'RequirementHandlerRankingList',
		'RequirementInspectorRankingList', 'NoticePage'
	])
	// track_centre 项目中心  track_centre_show_hide 项目中心-右侧展开/收起  track_todo 我的待办  track_create 我的创建  archive_member_type 成员档案--材料
	// archive_overall_type 综合档案--材料  archive_overall_material_type 综合档案--材料类型  archive_warning_type 档案预警  archive_device_register_type 设备登记  archive_device_type 设备登记--类别情况  archive_device_approve_type 设备审批
	// group_member 成员信息  group_department 部门管理  group_change_log 变更日志  customized_path_info 路径信息  track_project_left 项目追踪-项目中心-项目（左侧） archive_overall_project 档案库-综合档案-项目（左侧）
	// ref([])
	// ProjectCenter MyToDo MyCreate GeneralArchive MemberArchive ExpirationWarning EquipmentRegistration EquipmentApproval MemberAccount DepartmentManagement ChangeLogs PathInformation
	// ref(['ExpirationWarning', 'GeneralArchive']) 
	// 缓存页面 项目中心/我的待办/我的创建/成员档案/综合档案/档案预警/设备登记/设备审批/成员信息/部门管理/变更日志/路径信息/项目追踪-项目中心-项目（左侧）档案库-综合档案-档案（左侧）
	const theme = ref(localStorage.getItem('userConfigData') ? JSON.parse(localStorage.getItem(
		'userConfigData')).theme : 'dark')
	const isLogin = ref(localStorage.getItem('isLogin') ? Number(localStorage.getItem('isLogin')) :
		null) // null 未登录
	// 获取安全设置信息
	const configusersafeInfoMess = ref(localStorage.getItem('configusersafeInfoMess') ? JSON.parse(localStorage
		.getItem('configusersafeInfoMess')) : {})
	const configcompanydeployInfoMess = ref(localStorage.getItem('configcompanydeployInfoMess') ? JSON.parse(
		localStorage.getItem('configcompanydeployInfoMess')) : {})
	const isRefreshDashboard = ref(false) // 页面刷新
	// 获取自定义配置
	const userConfigData = ref(localStorage.getItem('userConfigData') ? JSON.parse(localStorage.getItem(
		'userConfigData')) : {})
	// 服务站--待处理数量
	const servicesTopNumData = ref(localStorage.getItem('servicesTopNumData') ? JSON.parse(localStorage.getItem(
		'servicesTopNumData')) : {})
	const collectData = ref(localStorage.getItem('collectData') ? JSON.parse(localStorage.getItem(
		'collectData')) : {})
	// 获取档案配置
	const archiveConfigData = ref(localStorage.getItem('archiveConfigData') ? JSON.parse(localStorage.getItem(
		'archiveConfigData')) : {})
	// 获取项目配置
	const projectConfigData = ref(localStorage.getItem('projectConfigData') ? JSON.parse(localStorage.getItem(
		'projectConfigData')) : {})
	// 获取路径配置
	const pathConfigData = ref(localStorage.getItem('pathConfigData') ? JSON.parse(localStorage.getItem(
		'pathConfigData')) : {})
	const isMenu = ref(false)
	const isCollapse = ref(userConfigData.value.sideModel === 'sideFloat' ? false : true) // 左侧侧边栏展示收起 true
	const isClick = ref(userConfigData.value.sideModel === 'sideFloat' ? true : false) // 左侧侧边栏展示收起--点击 false
	const isHover = ref(false) // 左侧侧边栏展示收起--悬浮
	const isFixed = ref(false) // 左侧侧边栏展示收起--固定侧边栏
	const noRead = ref(localStorage.getItem('noRead') ? localStorage.getItem('noRead') : 0)
	const approvalNum = ref(localStorage.getItem('approvalNum') ? Number(localStorage.getItem('approvalNum')) :
		0)
	const sidebarType = ref('') // 当前的展开菜单类型 系统通知/档案库/我的信息
	const sidebarObj = ref({}) // 左侧菜单数据
	const defaultOpeneds = ref(['0', '1', '2', '3', '4', '5']) // 默认展开所有菜单
	// 1、表示自己的企业，展示平台消息和全部菜单
	// 2、表示非自己的企业，不展示平台消息和全部菜单，只展示特定的功能
	const isHavePerssion = ref(localStorage.getItem('isHavePerssion') ? Number(localStorage.getItem(
		'isHavePerssion')) : 0) // 是否有菜单权限  1公测/0内测true有权限
	const isModal = ref(false) // 当前是否为点击弹窗（所有） 为弹窗时并且会限制页面的键盘监听***
	const countdown = ref(9) // 倒计时
	const setIntervalTime = ref(null) // 倒计时定时
	const isPrintShow = ref(false) // 共享打印/公告用到的
	const navMenuData = ref([]) // 获取顶部导航栏动态数据
	const companyserviceConfigData = ref(localStorage.getItem('companyserviceConfigData') ? JSON.parse(
		localStorage.getItem('companyserviceConfigData')) : {})
	const feedbackSubmit = ref(0) // 问题反馈提交 1提交 0重置
	const leftMenuData = ref(localStorage.getItem('leftMenuData') ? JSON.parse(localStorage.getItem(
		'leftMenuData')) : [])
	const menuKey = ref(0) // 实现强制刷新菜单

	// 获取用户信息 20260507 新增sync: 'yes'时查询更新sso数据 不传值正常返回数据
	function getInfoApi(params) {
		return new Promise((resolve, reject) => {
			getInfo(params).then(res => {
				if (res) {
					let data = res.data
					userInfo.value = data
					isLogin.value = 1
					if (data) {
						localStorage.setItem('userInfo', JSON.stringify(data))
					} else {
						localStorage.setItem('userInfo', '')
					}
					// console.log(data, 'data', useUserStore().userInfo)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 从 localStorage 加载数据并更新 state 用户信息
	function loadUserInfoStorage() {
		const raw = localStorage.getItem('userInfo');
		if (raw) {
			try {
				userInfo.value = JSON.parse(raw);
			} catch (e) {
				console.error('解析 localStorage 失败', e);
			}
		} else {
			// 可设置默认值
			userInfo.value = {};
		}
	}

	// 获取用户信息替代接口 20260226
	function getInfoProjectApi() {
		return new Promise((resolve, reject) => {
			getInfoProject().then(res => {
				if (res) {
					const data = res.data
					userInfo.value = {
						...userInfo.value,
						...data
					}

					if (data) {
						// console.log(useUserStore().userInfo, 'userInfo.value getInfoProjectApi')
						localStorage.setItem('userInfo', JSON.stringify(userInfo.value))
					}

					// console.log(data, 'data', useUserStore().userInfo)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 获取安全设置信息
	function configusersafeInfoApi() {
		return new Promise((resolve, reject) => {
			configusersafeInfo().then(res => {
				if (res) {
					let data = res.data
					configusersafeInfoMess.value = data
					localStorage.setItem('configusersafeInfoMess', JSON.stringify(data))
					resolve(res)
				} else {
					resolve()
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 获取集团默认配置
	function configcompanydeployInfoApi() {
		return new Promise((resolve, reject) => {
			configcompanydeployInfo().then(res => {
				if (res) {
					let data = res.data
					configcompanydeployInfoMess.value = data
					localStorage.setItem('configcompanydeployInfoMess', JSON.stringify(data))
					resolve(res)
				} else {
					resolve()
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 从 localStorage 加载数据并更新 state 自定义配置
	function loadUserConfigDataStorage() {
		const raw = localStorage.getItem('userConfigData');
		if (raw) {
			try {
				userConfigData.value = JSON.parse(raw);
			} catch (e) {
				console.error('解析 localStorage 失败', e);
			}
		} else {
			// 可设置默认值
			userConfigData.value = {
				shortcutModelArr: []
			};
		}
	}

	// 获取自定义配置
	function configuserpersonalizedInfoApi() {
		return new Promise((resolve, reject) => {
			configuserpersonalizedInfo().then(res => {
				if (res) {
					const data = res.data
					userConfigData.value = data
					if (data) {
						const sideModel = data.sideModel

						if (sideModel === 'sideFloat') {
							isCollapse.value = false
							isClick.value = true
						} else {
							isCollapse.value = true
							isClick.value = false
						}

						localStorage.setItem('userConfigData', JSON.stringify(data))
					} else {
						localStorage.setItem('userConfigData', '')
					}

					// console.log(userConfigData.value, theme.value, 'data', useUserStore()
					// 	.userConfigData)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}
	
	// 从 localStorage 加载数据并更新 state 服务站--待处理数量
	function loadServicesTopNumDataStorage() {
		const raw = localStorage.getItem('servicesTopNumData');
		if (raw) {
			try {
				servicesTopNumData.value = JSON.parse(raw);
			} catch (e) {
				console.error('解析 localStorage 失败', e);
			}
		} else {
			// 可设置默认值
			servicesTopNumData.value = {};
		}
	}

	// 服务站--顶部各状态个数统计
	function sysnoticeservicestationTopNuminfoApi() {
		return new Promise((resolve, reject) => {
			sysnoticeservicestationTopNuminfo().then(res => {
				if (res) {
					let data = res.data
					servicesTopNumData.value = data
					if (data) {
						localStorage.setItem('servicesTopNumData', JSON.stringify(data))
					} else {
						localStorage.setItem('servicesTopNumData', '')
					}
					// console.log(servicesTopNumData.value, 'data', useUserStore()
					// 	.servicesTopNumData)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 获取档案配置
	function configarchiveInfoApi() {
		return new Promise((resolve, reject) => {
			configarchiveInfo().then(res => {
				if (res) {
					let data = res.data
					archiveConfigData.value = data
					if (data) {
						localStorage.setItem('archiveConfigData', JSON.stringify(data))
					} else {
						localStorage.setItem('archiveConfigData', '')
					}
					// console.log(archiveConfigData.value, 'data', useUserStore()
					// 	.archiveConfigData)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 获取项目配置
	function configprojecttrackingInfoApi() {
		return new Promise((resolve, reject) => {
			configprojecttrackingInfo().then(res => {
				if (res) {
					let data = res.data
					projectConfigData.value = data
					if (data) {
						localStorage.setItem('projectConfigData', JSON.stringify(data))
					} else {
						localStorage.setItem('projectConfigData', '')
					}
					// console.log(projectConfigData.value, 'data', useUserStore()
					// 	.projectConfigData)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 获取全部的收藏的菜单
	function corecollectListAllApi() {
		return new Promise((resolve, reject) => {
			corecollectListAll().then(res => {
				if (res) {
					let data = res.data
					collectData.value = data
					if (data) {
						localStorage.setItem('collectData', JSON.stringify(data))
					} else {
						localStorage.setItem('collectData', '')
					}
					// console.log(collectData.value, 'data', useUserStore().collectData)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}
	
	// 从 localStorage 加载数据并更新 state 站内信未读数量
	function loadNoReadStorage() {
		const raw = localStorage.getItem('noRead');
		if (raw) {
			try {
				noRead.value = raw;
			} catch (e) {
				console.error('解析 localStorage 失败', e);
			}
		} else {
			// 可设置默认值
			noRead.value = 0
		}
	}

	// 获取站内信--未读数量
	function sysnoticestationletterUserStationLetterNumApi() {
		return new Promise((resolve, reject) => {
			sysnoticestationletterUserStationLetterNum().then(res => {
				if (res) {
					let data = res.data.noRead
					noRead.value = data
					if (data) {
						localStorage.setItem('noRead', data)
					} else {
						localStorage.setItem('noRead', '')
					}
					// console.log(noRead.value, 'data', useUserStore().noRead)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}
	
	// 从 localStorage 加载数据并更新 state 设备审核中数量
	function loadApprovalNumStorage() {
		const raw = localStorage.getItem('approvalNum');
		if (raw) {
			try {
				approvalNum.value = Number(raw);
			} catch (e) {
				console.error('解析 localStorage 失败', e);
			}
		} else {
			// 可设置默认值
			approvalNum.value = 0
		}
	}
	
	// 获取设备审核中数量
	function archivedeviceapplyApprovalNumApi() {
		return new Promise((resolve, reject) => {
			archivedeviceapplyApprovalNum().then(res => {
				if (res) {
					let data = res.data
					approvalNum.value = data
					if (data) {
						localStorage.setItem('approvalNum', data)
					} else {
						localStorage.setItem('approvalNum', 0)
					}
					// console.log(approvalNum.value, 'data', useUserStore().approvalNum)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 获取缓存状态  项目中心/项目中心-右侧展开\收起/我的待办/我的创建/成员档案/综合档案/档案预警/设备登记/设备审批/档案库-综合档案-材料类型/档案库-设备登记-设备类别/成员信息/部门管理/变更日志/路径信息
	function cacheGetCacheTypeApi(type) {
		return new Promise((resolve, reject) => {
			cacheGetCacheType({
				type
			}).then(res => {
				if (res) {
					// 1存在缓存 0不存在
					// console.log(res, 'resres')
					if (res.data === '0') {
						resolve(true)
					} else {
						resolve(false)
					}
				}
				//  else {
				// 	console.log(res, 'resresres')
				// 	resolve(res)
				// }
			}).catch(error => {
				console.log(error)
				reject(error)
			})
		})
	}

	// 获取路径配置
	function configmenucustomizeInfoApi() {
		return new Promise((resolve, reject) => {
			configmenucustomizeInfo().then(res => {
				if (res) {
					let data = res.data
					pathConfigData.value = data
					if (data) {
						localStorage.setItem('pathConfigData', JSON.stringify(data))
					} else {
						localStorage.setItem('pathConfigData', '')
					}
					// console.log(pathConfigData.value, theme.value, 'data', useUserStore()
					// 	.pathConfigData)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 获取是否有获取平台消息菜单权限
	function sysnoticeconfigPlatformShowmApi() {
		return new Promise((resolve, reject) => {
			sysnoticeconfigPlatformShow().then(res => {
				if (res) {
					const data = res.data
					isHavePerssion.value = data
					// 1公版 0内测有权限
					localStorage.setItem('isHavePerssion', data || 0)
					// console.log(isHavePerssion.value, 'data', useUserStore().isHavePerssion)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 获取顶部导航栏动态数据
	function sysmenupowerDynamicMenuApi() {
		return new Promise((resolve, reject) => {
			sysmenupowerDynamicMenu().then(res => {
				if (res) {
					const data = res.data
					navMenuData.value = data
					// console.log(navMenuData.value, 'data', useUserStore().navMenuData)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}

	// 获取企业配置数据
	function configcompanyserviceInfoApi() {
		return new Promise((resolve, reject) => {
			configcompanyserviceInfo().then(res => {
				if (res) {
					const data = res.data
					companyserviceConfigData.value = data
					if (data) {
						localStorage.setItem('companyserviceConfigData', JSON.stringify(data))
					} else {
						localStorage.setItem('companyserviceConfigData', '')
					}
					// console.log(companyserviceConfigData.value, 'data', useUserStore()
					// 	.companyserviceConfigData)
					resolve(res)
				} else {
					resolve(res)
				}
			}).catch(error => {
				reject(error)
			})
		})
	}


	/**
	 * 登录
	 */
	function handleLogin() {
		return new Promise((resolve, reject) => {
			// 当随机数大于0.8时，成功登录
			if (Math.random() > 0.8) {
				loginStatus.value = true
				token.value = String(new Date().getTime())
				userInfo.value = {
					name: 'admin',
					avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80',
				}
				resolve('登录成功')
			} else {
				reject('登录失败')
			}
		})
	}

	/**
	 * 退出登录
	 */
	function handleLogout() {
		return new Promise(resolve => {
			loginStatus.value = false
			token.value = ''
			userInfo.value = {}
			resolve()
		})
	}

	return {
		userInfo,
		loadUserInfoStorage,
		loginStatus,
		token,
		cachedViews,
		theme,
		isLogin,
		getInfoApi,
		getInfoProjectApi,
		handleLogin,
		handleLogout,
		configusersafeInfoMess,
		configusersafeInfoApi,
		configcompanydeployInfoMess,
		configcompanydeployInfoApi,
		isRefreshDashboard,
		userConfigData,
		loadUserConfigDataStorage,
		configuserpersonalizedInfoApi,
		servicesTopNumData,
		loadServicesTopNumDataStorage,
		sysnoticeservicestationTopNuminfoApi,
		collectData,
		corecollectListAllApi,
		isMenu,
		isCollapse,
		isClick,
		isHover,
		isFixed,
		archiveConfigData,
		configarchiveInfoApi,
		projectConfigData,
		configprojecttrackingInfoApi,
		pathConfigData,
		configmenucustomizeInfoApi,
		noRead,
		loadNoReadStorage,
		sysnoticestationletterUserStationLetterNumApi,
		cacheGetCacheTypeApi,
		approvalNum,
		loadApprovalNumStorage,
		archivedeviceapplyApprovalNumApi,
		sidebarType,
		sidebarObj,
		defaultOpeneds,
		isHavePerssion,
		sysnoticeconfigPlatformShowmApi,
		isModal,
		countdown,
		setIntervalTime,
		isPrintShow, // 共享打印/公告用到的
		sysmenupowerDynamicMenuApi,
		navMenuData,
		configcompanyserviceInfoApi,
		companyserviceConfigData,
		feedbackSubmit,
		leftMenuData,
		menuKey
	}
})

export default useUserStore